import { useEffect, useState, forwardRef } from 'react';
import { PayedUpload } from '../../../../../types/Indicators.type';
import { formatDateAndTime } from '../../../../../common/helpers/date.helpers';

interface FileInputProps {
  onChange?: (file: string) => void;
  pathToUpload: string;
  resourceId?: string;
  resource?: string;
  name?: string;
  currentPath: PayedUpload[] | [];
}

export const IndicatorProofofPayments = forwardRef<HTMLInputElement, FileInputProps>(
  ({ currentPath }) => {
    const [pathsList, setPathsList] = useState<PayedUpload[]>(currentPath);

    useEffect(() => {
      setPathsList(currentPath);
    }, [currentPath]);

    return (
      <div>
        {pathsList.length == 0 ?
          <span className="py-2 flex">Nenhum comprovante enviado</span> :
          pathsList.map((path, index) => (
            <span key={index} className="py-2 flex">
              <a href={`https://assets.locavibe.com.br/${path.file}`} className="text-bluePrimary" target="_blank">
                {formatDateAndTime(path.createAtPayed)} - {(path.file.split("/").reverse()[0]).split("-")[1]}
              </a>
            </span>
          ))}
      </div>
    );
  });
